// extracted by mini-css-extract-plugin
export var orderDetails = "_mc-2";
export var orderImage = "_mc-1";
export var orderMeta = "_mc-3";
export var orderSummary = "_mc-0";
export var rightArrow = "_mc-4";